import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import { width } from './constants';
import { sliderOptions } from './hooks/useSliderItemConfig';

// eslint-disable-next-line import/prefer-default-export
export const CarouselItem = styled.img`
  border-radius: 3px;
  object-fit: cover;
  height: 107px;
  width: ${width.mobile}px;
  margin: 0 auto;

  @media screen and (min-width: ${legacyBreakpoints.m}px) {
    height: 181px;
    width: ${width.tablet}px;
  }

  @media screen and (min-width: ${legacyBreakpoints.l}px) {
    height: 254px;
    width: ${width.desktop}px;
  }
`;

export const Wrapper = styled.div.attrs({
  className: 'overflow-hidden relative w-full m:min-h-280px'
})`
  padding: 25px 0 0;

  .slick-slider {
    @media screen and (min-width: ${legacyBreakpoints.l}px) {
      display: flex;
      justify-content: center;
    }
  }

  .slick-list {
    margin: auto;
    overflow: visible;
    width: ${width.mobile + sliderOptions.mobile.cellSpacing}px;

    @media screen and (min-width: ${legacyBreakpoints.m}px) {
      width: ${width.tablet + sliderOptions.tablet.cellSpacing}px;
    }

    @media screen and (min-width: ${legacyBreakpoints.l}px) {
      width: 1200px;
    }

    .slick-slide div {
      display: flex;
      justify-content: center;
    }
  }
`;

export const NavigationButton = createComponent('button', {
  className:
    'absolute top-[45%] z-1 hidden h-[58px] w-[58px] items-center justify-center rounded-full bg-white text-blue-2 shadow-legacy l:flex'
});
